import {
  getQueryStringVariable,
  getVH,
  getVW,
  getElementHeight,
  getFullWidth,
  getFullHeight,
  getScrollTop, debounce
} from "./utilities";

/**
 * Controls the content, title, and background functionality for all sections in the site.
 *
 */
let SectionManager = function (params) {
  // console.log('SectionManager initalizing ' + params);

  let self = this;
  let parentWrapper = document.getElementById('bp3-wrapper');
  let progressLine = parentWrapper.querySelector('#progress-line');
  let progressLineFixed = parentWrapper.querySelector('#progress-line-fixed');
  // console.log('wrapped progress line is ', progressLine)
  // console.log('progress line fixed is ', progressLineFixed)
  // TODO: add a current section variable for play/pause bg video on nav open/close?

  let markers = false;
  if (getQueryStringVariable('markers') === 'true') {
    markers = true;
  }
  // markers = false;

  ScrollTrigger.defaults({
    // bg crossfade values
    // start: '0% 60%',
    // end: '0% 40%',
    // markers: markers,
    // scrub: true,
    // scroll: document.body,
    // invalidateOnRefresh: true,
    // scroller: '#scroll-wrapper',
    anticipatePin: 1
  });

  // section 1 title fade has to happen BEFORE the section loops
  let section1Title = parentWrapper.querySelector('#section1-title').querySelector('h2');
  gsap.fromTo(section1Title, {opacity: 0}, {
    scrollTrigger: {
      id: 'section 1 title',
      start: '0% 40%',
      end: '0% 20%',
      scrub: true,
      snap: false,
      trigger: '#section1-content',
      markers: markers,
      toggleActions: "play none none complete",
      // toggleActions: "play reset reset reset",
    },
    opacity: 1,
    onComplete: function () {
      let titleH2 = parentWrapper.querySelector('#section1-title').querySelector('h2');
      gsap.to(titleH2, {backgroundImage: '-webkit-linear-gradient(45deg, #525b5c, #FFFFFF)', duration: 3});
    }
  });
  // fade/slide in section 1 subtitle BEFORE the section loops
  gsap.fromTo('#section1-subtitle', {opacity: 0, x: -400}, {
    scrollTrigger: {
      id: 'section 1 subtitle',
      start: '0% 20%',
      end: '0% 00%',
      scrub: false,
      trigger: '#section1-content',
      markers: false,
      // toggleActions: "play none none reverse",
      toggleActions: "play complete reverse reset"
    },
    opacity: 1,
    x: 0,
    duration: 0.3
  });

  // loop through content-wrappers and pin them
  let sectionElement;
  let sectionContents;
  self.sectionCount = parentWrapper.querySelectorAll('.section-content').length;
  // NOTE: 2 content loops one for content pinning which adjusts section height, then a second for section bg/title transitions!
  for (let index = 1; index <= self.sectionCount; index++) {
    // console.log('section number ' + index);

    // get the section content reference, then loop through content-wrappers to pin them individually
    sectionElement = parentWrapper.querySelector('#section' + index.toString() + '-content');
    sectionContents = sectionElement.querySelectorAll(".content-wrapper");
    let quoteSplitText = null;
    let quoteTimeline = null;
    sectionContents.forEach(function(content) {
      let sectionPin = new ScrollTrigger({
        id: 'section ' + index.toString() + ' content',
        // use function for dynamic title height for subtitles and wrapping titles
        start: function (params) {
          // console.log('start ', params.pin.id);
          // get the dynamic height for the pin accounting for top pads, title wraps, and subtitles
          let logoHeight = getElementHeight('#logo-black');
          logoHeight = 0;
          let titleHeight = getElementHeight('#section' + index.toString() + '-title');
          let vh = getVH(10);
          let startPin = Math.round(logoHeight + titleHeight + vh);
          // Not Using this anymore? keeping just to be safe...
          // store this value on the window for later use with the side progress line
          // window['startPin' + index.toString()] = startPin;
          let startString = '0 ' + startPin.toString();
          // console.log('start string is now ' + startString);
          return startString;
        },
        // static pin value, using percents here contributes to resize bugs
        end: "+=500",
        pin: true,
        markers: markers,
        trigger: content,
        endTrigger: content,
        onEnter: function (params) {
          // console.log('content pin at ' + getScrollTop());
          // console.log('enter ', params.pin.id);
          // animate the quotes
          let quote = params.pin.querySelector('.quote');
          if (quote !== null) {
            // reset any running split texts
            if (quoteSplitText !== null && quoteTimeline !== null) {
              quoteTimeline.kill();
              gsap.killTweensOf(quoteSplitText.words);
              gsap.set(quoteSplitText.words, {scale: 1, color:"#ffffff"});
              quoteSplitText.revert();
              quoteSplitText = null;
              quoteTimeline = null;
            }
            // individual words
            quoteSplitText = new SplitText(quote, {type: 'words'});
            quoteTimeline = gsap.timeline({
              // onCompleteParams: [quoteSplitText],
              onComplete: function (params) {
                // console.log('quote split text revert ', quoteSplitText);
                if (quoteSplitText !== null && quoteTimeline !== null) {
                  quoteTimeline.kill();
                  gsap.killTweensOf(quoteSplitText.words);
                  gsap.set(quoteSplitText.words, {scale: 1, color: "#ffffff"});
                  quoteSplitText.revert();
                  quoteSplitText = null;
                  quoteTimeline = null;
                }
              }
            });
            quoteTimeline.to(quoteSplitText.words, {duration: 0.2, color:"#8c9292", scale:0.9, stagger: 0.2}, "words");
            quoteTimeline.to(quoteSplitText.words, {duration: 0.4, color:"#ffffff", scale:1, stagger: 0.2}, "words+=0.2");
            quoteTimeline.play();
          }

          // show the schematic
          let preview = params.pin.querySelector('#section1-preview')
          if (preview !== null) {
            window.bp3Application.schematic.show();
          }
        },
        onLeaveBack: function (params) {
          // console.log('leave back ', params.pin.id);
          // reset the red line
          let line = params.pin.querySelector('.line');
          gsap.to(line, {height: 15});
          // hide the schematic
          let preview = params.pin.querySelector('#section1-preview')
          if (preview !== null) {
            window.bp3Application.schematic.hide();
          }
        },
        onLeave: function (params) {
          // console.log('leave ', params.pin.id);

          if (index !== self.sectionCount) {
            // fade the content out
            let targets = params.pin.querySelectorAll('.fade');
            if (targets !== null) {
              gsap.to(targets, {opacity: 0});
            }
            let line = params.pin.querySelector('.line');
            gsap.to(line, {height: 15});
          } else {
            // fade the first one but not the second
            if (params.pin.id === 'section' + self.sectionCount.toString() + '-first-content') {
              // fade the content out
              let targets = params.pin.querySelectorAll('.fade');
              if (targets !== null) {
                gsap.to(targets, {opacity: 0});
              }
              let line = params.pin.querySelector('.line');
              gsap.to(line, {height: 15});
              // swap the subtitles
              // let sub1 = parentWrapper.querySelector('#section18-title').querySelector('.subtitle1');
              // let sub2 = parentWrapper.querySelector('#section18-title').querySelector('.subtitle2');
              // gsap.to(sub1, {opacity: 0, x: 400, duration: 0.25, onComplete: function () {
              //     gsap.set(sub2, {opacity: 0, x: -200});
              //     gsap.to(sub2, {opacity: 1, x: 0, duration: 0.25});
              //   }});
            }
          }
        },
        onEnterBack: function (params) {
          // console.log('enter back ', params.pin.id);
          // fade the content back in
          let targets = params.pin.querySelectorAll('.fade');
          if (targets !== null) {
            gsap.to(targets, {opacity: 1});
          }

          // fade the first one but not the second
          // if (params.pin.id === 'section18-first-content') {
          //   // swap the subtitles
          //   let sub1 = parentWrapper.querySelector('#section18-title').querySelector('.subtitle1');
          //   let sub2 = parentWrapper.querySelector('#section18-title').querySelector('.subtitle2');
          //   gsap.to(sub2, {opacity: 0, x: 400, duration: 0.25, onComplete: function () {
          //       gsap.set(sub1, {opacity: 0, x: -200});
          //       gsap.to(sub1, {opacity: 1, x: 0, duration: 0.25});
          //     }});
          // }
        },
        onUpdate: function ({progress}) {
          // console.log('update ', progress);
          // update the red progress line marker
          let line = content.querySelector('.line');
          let heightWrapper = content.querySelector('.height-wrapper');
          let lineHeight = Math.round((heightWrapper.offsetHeight * progress));
          if (lineHeight < 15) {
            lineHeight = 15;
          }
          gsap.set(line, {height: lineHeight});
        },
        onRefresh: function (params) {
          // console.log('Refresh ', params);
          if (params.trigger.id != null && params.trigger.id.indexOf('first-content') !== -1) {
            window.bp3Application.setFirstContentPosition(index, Math.round((params.start + params.end)/2));
          }
        }
      });


      // animate content as it enters screen
      let textContent = content.querySelectorAll('p');
      let videoContent = content.querySelector('.video-preview');
      // split text roll animation on content as it enters the screen
      if (textContent !== null && textContent.length > 0) {
        // remove quotes from the roll on animation to avoid embedded split text spacing bug
        let quoteContent = content.querySelectorAll('.quote');
        if (quoteContent !== null && quoteContent.length > 0) {
          // console.log('FOUND QUOTE skipping enter animation');
        } else {
          // console.log('textContent is ', textContent);
          let contentSplitText = null;
          let contentSplitTimeline = null;
          let contentAnimations = new ScrollTrigger({
            id: 'section ' + index.toString() + ' content',
            start: '0% 100%',
            end: '100% 50%',
            markers: markers,
            trigger: content,
            scrub: false,
            onEnter: function (params) {
              // console.log('enter ', params);
              // console.log('revert1 ' + index);
              if (contentSplitText !== null && contentSplitTimeline !== null) {
                contentSplitTimeline.kill();
                gsap.killTweensOf(contentSplitText.lines);
                gsap.set(contentSplitText.lines, {opacity: 1, rotationX: 0, transformOrigin: "50% 50% 0"});
                contentSplitText.revert();
                contentSplitText = null;
                contentSplitTimeline = null;
              }
              contentSplitText = new SplitText(textContent, {type: 'lines'});
              contentSplitTimeline = gsap.timeline({
                onComplete: function () {
                  // console.log('revert2 ' + index);
                  if (contentSplitText !== null && contentSplitTimeline !== null) {
                    contentSplitTimeline.kill();
                    gsap.killTweensOf(contentSplitText.lines);
                    gsap.set(contentSplitText.lines, {opacity: 1, rotationX: 0, transformOrigin: "50% 50% 0"});
                    contentSplitText.revert();
                    contentSplitText = null;
                    contentSplitTimeline = null;
                  }
                }
              });
              // contentSplitTimeline.onComplete = function () {
              //   console.log('revert2 ' + index);
              //   if (contentSplitText !== null && contentSplitTimeline !== null) {
              //     contentSplitTimeline.kill();
              //     gsap.killTweensOf(contentSplitText.lines);
              //     gsap.set(contentSplitText.lines, {opacity: 1, rotationX: 0, transformOrigin: "50% 50% 0"});
              //     contentSplitText.revert();
              //     contentSplitText = null;
              //     contentSplitTimeline = null;
              //   }
              // };
              gsap.set(textContent, {perspective: 400});
              contentSplitText.split({type: 'lines'});
              contentSplitTimeline.fromTo(contentSplitText.lines, {
                opacity: 0,
                rotationX: -120,
                force3D: true,
                transformOrigin: "50% 0% -50"
              }, {
                duration: 0.5,
                opacity: 1,
                rotationX: 0,
                force3D: true,
                // transformOrigin: "50% 50% 0",
                stagger: 0.05
              });
              contentSplitTimeline.play();
            }
          });
        }

      // video scale in animations
      } else if (videoContent !== null) {
        // console.log('video');
        gsap.set(videoContent, {scale: 0});
        gsap.fromTo(videoContent, {scale: 0}, {scale: 1, ease: 'back.out(1.2)', duration: 1.5,
          scrollTrigger: {
            id: 'section ' + index.toString() + ' video',
            start: '0% 100%',
            // TODO: make dynamic function based on bottom of content hit point?
            end: '0% 40%',
            scrub: false,
            markers: markers,
            trigger: content,
            toggleActions: "play none none reset",
            onEnter: function (params) {
              // console.log('enter ', params);
              gsap.fromTo(videoContent, {y: 100}, {y: 0, duration: 1.5, ease: 'power1.out'});
            }
          }
        });
      }

    }); // end foreach content loop in each section

  } // end forward section loop



  // TODO: make another loop that makes sure all pinned content-wrappers set opacity 0 when the bottom scrolls in the top edge?



  // second loop for section transitions
  for (let index = 1; index <= self.sectionCount; index++) {
    // console.log('section number ' + index);
    sectionElement = parentWrapper.querySelector('#section' + index.toString() + '-content');
    sectionContents = sectionElement.querySelectorAll(".content-wrapper");

    let oldBackground = '#section' + (index - 1).toString() + '-bg';
    let newBackground = '#section' + (index).toString() + '-bg';
    // new timeline section transition for bgs and titles
    if (index > 1) {
      let sectionTimeline = gsap.timeline({
        scrollTrigger: {
          id: 'section ' + index.toString() + ' transition',
          trigger: '#section' + index.toString() + '-content',
          markers: markers,
          start: '0% 95%',
          end: '0% 20%',
          snap: {
            snapTo: function(value, params) {
              if (params.direction > 0) {
                return 1;
              } else {
                return 0;
              }
            },
            // duration: {min: 0.2, max: 1},
            // delay: 0
          },
          scrub: false,
          toggleActions: "play complete reverse reset",
          // toggleActions: "play complete reverse reverse",
          // toggleActions: "play complete complete reset",
          onEnter: function (params) {
            console.log('enter current ' + index.toString());
            let currentVideo = parentWrapper.querySelector('#section' + index.toString() + '-bg-video')
            if (currentVideo !== null) {
              currentVideo.play();
              // console.log('played ', currentVideo);
            }
            window.bp3Application.schematic.removePin();
            if (index === 18) {
              // console.log('hide schematic');
              window.bp3Application.schematic.hide();
            }
            // starting the section transition - turn on the next sections bg
            gsap.set(newBackground, {display: 'block'});
          },
          onEnterBack: function (params) {
            console.log('enter back ', index.toString());
            let previousVideo = parentWrapper.querySelector('#section' + (index - 1).toString() + '-bg-video')
            if (previousVideo !== null) {
              previousVideo.play();
              // console.log('played ', previousVideo);
            }
            // show intro bg
            if (index === 2) {
              // console.log('show intro bg');
              gsap.set('#intro-bg', {display: 'block'});
            }
            window.bp3Application.schematic.removePin();

            // starting the reverse section transition - turn on the previous sections bg
            gsap.set(oldBackground, {display: 'block'});
          },
          onLeave: function (params) {
            console.log('leave ' + index.toString());
            let previousVideo = parentWrapper.querySelector('#section' + (index - 1).toString() + '-bg-video')
            if (previousVideo !== null) {
              previousVideo.pause();
              // console.log('paused ', previousVideo);
            }
            window.bp3Application.setCurrentSectionIndex(index);
            // hide intro bg
            if (index === 2) {
              // console.log('hide intro bg');
              gsap.set('#intro-bg', {display: 'none'});
            }
            window.bp3Application.schematic.dropPin();

            // finishing the section transition - turn off the previous sections bg
            gsap.set(oldBackground, {display: 'none'});
          },
          onLeaveBack: function (params) {
            console.log('leave back ' + index.toString() + ' scroll is ' + getScrollTop());
            let currentVideo = parentWrapper.querySelector('#section' + index.toString() + '-bg-video')
            if (currentVideo !== null) {
              currentVideo.pause();
              // console.log('paused ', currentVideo);
            }
            window.bp3Application.setCurrentSectionIndex(index - 1);
            window.bp3Application.schematic.dropPin();
            if (index === 18) {
              // console.log('show schematic back');
              window.bp3Application.schematic.show();
              gsap.to('#sections-gradient2', {scale: 1, duration: 0.5, ease: 'power3.easeout'});
            }

            // finishing the reverse section transition - turn off the next sections bg
            gsap.set(newBackground, {display: 'none'});
          },
          onRefresh: function (params) {
            // console.log('*** REFRESH ' + index + ' ', params);
            // console.log('scrolls - ' + params.start + ' to ' + params.end + ' current ' + getScrollTop());
            // console.log('progress ' + params.progress);
            window.bp3Application.setSectionMarkers(index, params.start, params.end);
            // catch bug where section 1 title reappears after resize/orientation change
            if (window.bp3Application.currentSectionIndex !== 1) {
              let section1H2 = parentWrapper.querySelector('#section1-title').querySelector('h2');
              gsap.set(section1H2, {opacity: 0});
            }
          }
        }
      });

      let step = 0.25;
      // let oldBackground = '#section' + (index - 1).toString() + '-bg';
      if (index === 2) {
        oldBackground = '#intro-bg';
      }
      // let newBackground = '#section' + (index).toString() + '-bg';
      let newTitle = parentWrapper.querySelector('#section' + (index).toString() + '-title');
      let newTitleH2 = newTitle.querySelector('h2');
      let newTitleH4 = newTitle.querySelector('h4');

      sectionTimeline.to('h2', {x: 400, opacity: 0, duration: step, onReverseComplete: function () {
          // console.log('reverse complete on ' + index);
          gsap.set([newTitleH4, newTitleH2], {opacity: 0});
        }});
      sectionTimeline.to('h4', {x: 400, opacity: 0, duration: step}, "-=" + (step - 0.1).toString());

      sectionTimeline.to(oldBackground, {opacity: 0, duration: step}, "-=" + (step/2).toString());
      let oldContainer = parentWrapper.querySelector(oldBackground).querySelector('.motion-container');
      console.log('old container is ' + oldContainer);
      if (oldContainer !== null) {
        sectionTimeline.to(oldContainer, {scale: 0.8, y: -100, duration: step}, "<");
      }

      sectionTimeline.fromTo(newBackground, {opacity: 0}, {opacity: 1, duration: 1,
          onComplete: function () {
            if (index === 18) {
              gsap.to('#sections-gradient2', {scale: 1.35, duration: 2});
            }
          }
        }, "-=" + (step/2).toString());
      let newContainer = parentWrapper.querySelector(newBackground).querySelector('.motion-container');
      if (newContainer !== null) {
        sectionTimeline.fromTo(newContainer, {scale: 0.8, y: 100}, {scale: 1, y: 0, duration: 1}, "<");
      }

      sectionTimeline.to(newTitleH2, {backgroundImage: '-webkit-linear-gradient(45deg, #FFFFFF, #FFFFFF)', duration: 0.01});
      sectionTimeline.fromTo(newTitleH2, {x: -200, opacity: 0}, {x: 0, opacity: 1, duration: step}, "-=" + (step).toString());
      sectionTimeline.fromTo(newTitleH4, {x: -200, opacity: 0}, {x: 0, opacity: 1, duration: step, onComplete: function () {
          // console.log('section ' + index + ' + timeline last step complete current is ' + window.bp3Application.currentSectionIndex);
          gsap.to(newTitleH2, {backgroundImage: '-webkit-linear-gradient(45deg, #525b5c, #FFFFFF)', duration: 3});
        }}, "-=" + (step - 0.1).toString());

    }

  } // end backwards section loop





  // pin the progress line
  let lineTrigger = new ScrollTrigger({
    id: 'progress line',
    trigger: '#section2-content',
    start: '0% 60%',
    end: '0% 40%',
    markers: markers,
    scrub: false,
    onLeave: function (params) {
      progressLine.style.display = "none";
      progressLineFixed.style.display = 'block';
      // console.log('PIN THE LINE');
    },
    onLeaveBack: function (params) {
      progressLine.style.display = "block";
      progressLineFixed.style.display = 'none';
      // console.log('UNPIN THE LINE');
    }
  });
  // let endContent = parentWrapper.querySelector('#section19-content');
  let allContent = parentWrapper.querySelectorAll('.section-content');
  let endContent = allContent[allContent.length - 1];
  // get all the red dots and pull the progress line from the last one
  let dots = endContent.querySelectorAll('.red-dot');
  let endProgressLine = dots[dots.length -1].querySelector('.progress-line');
  // switch the progress line to a new line bottom aligned to the red dot on final content.
  let endLineTrigger = new ScrollTrigger({
    id: 'end progress line',
    trigger: endContent,
    start: '0% 100%',
    end: '100% 0%',
    markers: markers,
    onEnter: function () {
      // console.log('ENTER ', endProgressLine);
      endProgressLine.style.display = 'block';
      progressLineFixed.style.display = 'none';
      // console.log('hide bgs');
      // gsap.killTweensOf('#backgrounds');
      // gsap.to('#backgrounds', {opacity: 0, duration: 1});
    },
    onLeaveBack: function () {
      // console.log('LEAVE back ', endProgressLine);
      endProgressLine.style.display = 'none';
      progressLineFixed.style.display = 'block';
      // console.log('show bgs');
      // gsap.killTweensOf('#backgrounds');
      // gsap.to('#backgrounds', {opacity: 1, duration: 1});
    }
  });

  // switch the progress line to a new line bottom aligned to the red dot on final content.
  let footerTrigger = new ScrollTrigger({
    id: 'footer fade',
    trigger: endContent,
    start: '100% 80%',
    end: '100% 0%',
    markers: markers,
    onEnter: function () {
      // console.log('hide bgs');
      gsap.killTweensOf('#backgrounds');
      gsap.to('#backgrounds', {opacity: 0, duration: 0.5});
    },
    onLeaveBack: function () {
      // console.log('show bgs');
      gsap.killTweensOf('#backgrounds');
      gsap.to('#backgrounds', {opacity: 1, duration: 0.5});
    }
  });

  // pin the titles
  const titlePin = new ScrollTrigger({
    id: 'titles',
    trigger: '#logo-black',
    endTrigger: '#content',
    pin: '#titles',
    pinSpacing: false,
    start: '0% 2%',
    end: '100% 100%',
    markers: markers,
    scrub: false,
    onEnter: function () {
      gsap.to('#logo-black', {opacity: 0, duration: 0.25});
    },
    onLeaveBack: function () {
      gsap.to('#logo-black', {opacity: 1, duration: 0.25});
    }
  });

  // bouncing scroll arrow
  let arrowTween = gsap.to('.scroll-arrow', {y: "+=10", repeat: -1, yoyo: true, duration: 1});
  let scrollArrow = parentWrapper.querySelector('.scroll-arrow');
  scrollArrow.addEventListener('click', function () {
    console.log('arrow clicked');
    // window.scrollTo({top: Math.round(getFullHeight() / 1), behavior: 'smooth'});
    gsap.to(window, {duration: 2, scrollTo: Math.round(getFullHeight())});
  })
  // fade out intro gradient, scroll arrow, and dark logo
  gsap.fromTo('#intro-gradient1', {opacity: 1}, {
    scrollTrigger: {
      id: 'intro-gradient',
      trigger: '#intro-content',
      start: '5% 5%',
      end: '100% 25%',
      markers: markers,
      scrub: true,
      onEnter: function () {
        gsap.killTweensOf('#scroll-arrow');
        gsap.to('#scroll-arrow', {opacity: 0, duration: 0.5});
        // bring our nav in now that the titleist wrapper nav is out
        gsap.killTweensOf('#nav-button-wrapper');
        gsap.to('#nav-button-wrapper', {x: "-200", opacity: 1, duration: 0.5});
      },
      onLeaveBack: function () {
        gsap.killTweensOf('#scroll-arrow');
        gsap.to('#scroll-arrow', {opacity: 1, duration: 0.5});
        // take our nav away while titleist wrapper nav is in
        gsap.killTweensOf('#nav-button-wrapper');
        gsap.to('#nav-button-wrapper', {x: "0", duration: 0.5});
      },
      onLeave: function () {
        gsap.killTweensOf('#scroll-arrow');
        gsap.set('#scroll-arrow', {opacity: 0});
        arrowTween.pause();
      },
      onEnterBack: function () {
        arrowTween.play();
      }
    },
    opacity: 0
  });

  // fade out intro stuffs
  gsap.to('#intro-gradient2, #logo-black', {
    scrollTrigger: {
      id: 'white gradients',
      start: '0% 60%',
      end: '0% 40%',
      scrub: true,
      trigger: '#section1-content',
      markers: markers
    },
    opacity: 0
  });

  let introVideoBg = parentWrapper.querySelector('#intro-bg-video');
  // fade in section black gradients
  // gsap.to('#sections-gradient1, #sections-gradient2, #sections-gradient3', {
  gsap.to('#sections-gradient1, #sections-gradient2', {
    scrollTrigger: {
      id: 'black gradients',
      start: '0% 40%',
      end: '0% 20%',
      scrub: true,
      trigger: '#section1-content',
      markers: markers,
      toggleActions: "play none none complete",
      // toggleActions: "play complete reverse reset",
      onLeave: function () {
        // console.log('leave intro ' + getScrollTop());
        // pause the intro video
        if (introVideoBg !== null) {
          introVideoBg.pause();
        }
        gsap.set('#intro-title', {opacity: 0});
        window.bp3Application.setCurrentSectionIndex(1);
      },
      onEnter: function () {
        // console.log('enter intro');
      },
      onLeaveBack: function () {
        // console.log('leave back intro');
      },
      onEnterBack: function () {
        // console.log('enter back intro');
        // pause the intro video
        if (introVideoBg !== null) {
          introVideoBg.play();
        }
        gsap.set('#intro-title', {opacity: 1});
        window.bp3Application.setCurrentSectionIndex(0);
      },
      onRefresh: function (params) {
        // console.log('INTRO REFRESH ', params);
        window.bp3Application.setSectionMarkers(0, 0, params.end);
        window.bp3Application.setSectionMarkers(1, params.end, (params.end + 100));
      }
    },
    opacity: 1
  });

  // INTRO ANIMATION
  // let introSplitText2 = new SplitText('#intro-title', {type: 'words'});
  let introSplitText1 = new SplitText('#intro-words1', {type: 'words'});
  let introSplitText2 = new SplitText('#intro-words2', {type: 'words'});
  let introTimeline = gsap.timeline({
    onComplete: function () {
      // console.log('intro complete, unlock the scroll and show nav');
      document.body.style.overflowY = "scroll";
      gsap.set('#nav-button-wrapper', {display: 'block'});
      gsap.fromTo('#nav-button-wrapper', {opacity: 0}, {opacity: 1});
    }
  });
  introSplitText1.split({type: 'words'});
  introSplitText2.split({type: 'words'});
  gsap.set('#intro-title', {opacity: 1});
  introTimeline.fromTo('#logo-black', {opacity: 0}, {opacity: 1, duration: 1.5});
  // introTimeline.fromTo('#intro-title', {opacity: 0, y: '+=100'}, {opacity: 1, y: 0, duration: 1.5}, "-=1");
  introTimeline.fromTo(introSplitText1.words, {opacity: 0, y: '+=50'}, {opacity: 1, y: 0, duration: 0.75, stagger: 0.25, delay: 2}, "-=1");
  introTimeline.fromTo(introSplitText2.words, {opacity: 0, x: '+=400'}, {
    duration: 0.3,
    opacity: 1,
    x: 0,
    stagger: 0.4,
    // delay: '-0.5',
    onComplete: function() {
      introSplitText1.revert();
      introSplitText2.revert();
      // bug with scroll arrow stuck on quick scroll
      // document.body.style.overflowY = "scroll";
    }
  }, "-=0.2");
  introTimeline.fromTo('#scroll-arrow', {opacity: 0}, {opacity: 1, duration: 0.4});
  introTimeline.play();
  gsap.fromTo('#intro-gradient3', {opacity: 1}, {opacity: 0, duration: 3, delay: 1.5});
  window.scrollTo({top: 0});


  //TODO: try putting this on a refresh on a final empty scrolltrigger to remove the timer?
  window.addEventListener("orientationchange", function(event) {
    // console.log("the orientation changed: scroll at " + getScrollTop() + ' current section is ' + window.bp3Application.currentSectionIndex);
    let oldSectionId = window.bp3Application.currentSectionIndex;
    // let contentId = 'section' + window.bp3Application.currentSectionIndex.toString() + '-first-content';
    // let contentIndex = window.bp3Application.currentSectionIndex.toString();
    let timerId = setTimeout(function () {
      // console.log('ROTATION UPDATE current section is ' + window.bp3Application.currentSectionIndex);
      // console.log('ROTATION UPDATE old section id is ' + oldSectionId);
      window.bp3Application.setCurrentSectionIndex(oldSectionId);
      // TODO: scroll to a maintained/refresh reference to first content pin scroll position?
      // parentWrapper.getElementById(contentId).scrollIntoView();
      let position = window.bp3Application.firstContentPositions[oldSectionId];
      window.scrollTo({top: position});
    }, 1000);
  });

  let resizeTimerId;
  function resizeContent(){
    let position = window.bp3Application.firstContentPositions[ window.bp3Application.currentSectionIndex ];
    // make sure it updates?
    position = Math.round( position + (Math.random() * 13));
    window.scrollTo({top: position});
    // console.log('resize content ' + position);
  }
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimerId);
    resizeTimerId = setTimeout(resizeContent, 300);
  });


  // after everything loads do video checks
  window.addEventListener('load', function () {
    console.log('LOADED CHECKING VIDEOS ' + getFullWidth());
    if (getFullWidth() > 768) {
      console.log('adding in background videos');
      let videoElement = parentWrapper.querySelector('#intro-bg-video');
      let backgroundList = parentWrapper.querySelectorAll('.background');
      let videoClone;
      backgroundList.forEach(function(backgroundElement) {
        if (backgroundElement.getAttribute('data-src') !== null && backgroundElement.getAttribute('data-src') !== '' && videoElement !== null) {
          // get a new clone and set attributes
          videoClone = videoElement.cloneNode(true);
          videoClone.autoplay = false;
          videoClone.removeAttribute('autoplay');
          videoClone.pause();
          videoClone.id = backgroundElement.id.toString() + '-video';
          videoClone.querySelector('source').src = backgroundElement.getAttribute('data-src')
          videoClone.poster = backgroundElement.getAttribute('data-poster')
          // console.log('video clone is ', videoClone);
          let motionContainer = backgroundElement.querySelector('.motion-container');
          if (motionContainer !== null) {
            motionContainer.appendChild(videoClone);
          }
        }
      });
    }
  });
};

export default SectionManager;
